import { combineReducers } from "redux";

import signUpReducer from "./signup-reducer";
import signInReducer from "./signin-reducer";
import userReducer from "./user-reducer";
import refuelReducer from "./refuel-reducer";
import multiplosReducer from "./multiplos-reducer";
import firstAccessReducer from './first-access-reducer';
import membershipReducer from "./membership-reducer";
import addNewUnitReducer from "./add-new-unit-reducer";
import selectUnitReducer from "./select-unit-reducer";
import digitalWayReducer from "./digital-way-reducer";

export const reducers = combineReducers({
  signUpReducer,
  signInReducer,
  userReducer,
  refuelReducer,
  multiplosReducer,
  firstAccessReducer,
  membershipReducer,
  addNewUnitReducer,
  selectUnitReducer,
  digitalWayReducer
});
